import { HttpResponse, HttpService } from '@application/http.service';
import type { PaymentApiModel, PaymentServiceApiModel } from '@visiba/api-vcs-client-v2';
import { Injectable } from '@visiba/instantiation';
import { ApiBaseClient } from './_api_base_client';

@Injectable()
export class PaymentApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('');
	}

	public getServices(unitId: number, billId: number): HttpResponse<PaymentServiceApiModel[]> {
		return this.httpService.get(`${this.baseUri}/units/${unitId}/Payments/${billId}/Services`);
	}

	public getPayment(billId: number): HttpResponse<PaymentApiModel> {
		return this.httpService.get(`${this.baseUri}/Payments/${billId}`);
	}
}
